import { PlusOutlined } from '@ant-design/icons'
import { Col, DatePicker, TimePicker } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, Controller, SubmitHandler, UseFormHandleSubmit } from 'react-hook-form'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import utc from 'dayjs/plugin/utc'

import { useDestinations } from '@hooks'
import { CommonTicketForm, User } from '@types'

import { FormValidation } from './validations/validations'
import {
  StyledButton,
  StyledSelect,
  StyledContainer,
  StyledRow,
  StyledTitle,
  StyledButtonContainer,
} from '../components'

dayjs.extend(utc)

type OrigenProps = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  control: Control<FormValidation, object>
  userState: User | undefined
  handleNewTicket: (form: CommonTicketForm) => void
  handleSubmit: UseFormHandleSubmit<FormValidation>
}

export const Origen: React.FC<OrigenProps> = ({
  control,
  userState,
  handleNewTicket,
  handleSubmit,
}) => {
  const navigate = useNavigate()
  const { destinationsOptions } = useDestinations()

  const { t } = useTranslation()

  const handleReturn = () => {
    navigate('/dashboard/suppliers')
  }
  return (
    <StyledContainer>
      <StyledTitle>Seleccionar origen</StyledTitle>
      <Controller
        name="depotId"
        control={control}
        render={({ field }) => (
          <StyledSelect
            {...field}
            placeholder={t('form_mobile.origin')}
            options={userState?.userDetail.supplier?.depots.map(depot => ({
              label: depot.tag,
              value: depot.id,
            }))}
          />
        )}
      />
      <StyledButton
        style={{
          backgroundColor: '#579c5f',
          border: 'none',
          color: 'white',
          marginTop: '5px',
        }}
      >
        <PlusOutlined /> Nuevo carrier
      </StyledButton>
      <StyledRow>
        <Controller
          control={control}
          name="destinationId"
          render={({ field }) => (
            <StyledSelect
              placeholder={t('form_mobile.Origin')}
              options={destinationsOptions}
              {...field}
            />
          )}
        />
      </StyledRow>
      <StyledRow>
        <Controller
          name="ticketDate"
          control={control}
          defaultValue={dayjs().toDate()}
          render={({ field }) => (
            <DatePicker
              style={{ width: '100%' }}
              {...field}
              allowClear={false}
              value={field.value ? dayjs(field.value).utc() : undefined}
              picker="date"
              format="DD/MM/YYYY"
            />
          )}
        />
      </StyledRow>
      <StyledRow>
        <Controller
          control={control}
          name="ticketTime"
          render={() => (
            <TimePicker style={{ width: '100%' }} defaultValue={dayjs('00:00:00', 'HH:mm:ss')} />
          )}
        />
      </StyledRow>

      <StyledRow>
        <Col span={12}>
          <StyledButtonContainer>
            <StyledButton
              style={{
                backgroundColor: 'gray',
                border: 'none',
                color: 'white',
                margin: '0 2.5px 0 0',
              }}
              onClick={handleReturn}
            >
              Cancelar
            </StyledButton>
          </StyledButtonContainer>
        </Col>
        <Col span={12}>
          <StyledButtonContainer>
            <StyledButton
              style={{
                backgroundColor: '#579c5f',
                border: 'none',
                color: 'white',
                margin: '0 0 0 2.5px',
              }}
              onClick={handleSubmit(handleNewTicket as unknown as SubmitHandler<FormValidation>)}
            >
              Crear
            </StyledButton>
          </StyledButtonContainer>
        </Col>
      </StyledRow>
    </StyledContainer>
  )
}
